export const EVENTS = 'events';
export const USER_PROFILE_PHOTO = 'USER_PROFILE_PHOTO';
export const GROUP_MESSAGE = 'GROUP_MESSAGE';
export const CASE_AVATAR = 'CASE_AVATAR';
export const CONSULT_REQUEST = 'CONSULT_REQUEST';
export const OCCUPATIONAL_HEALTH_PDF = 'OCCUPATIONAL_HEALTH_PDF';
export const EMPLOYER_LOGO = 'EMPLOYER_LOGO';
